export const NAME = "login";

export const availableLanguages = ["EN", "DE", "ES", "FR", "IT", "NL", "PL"];
